module.exports = {"TXTWCL_Login_to_bet":{"id":"TXTWCL_Login_to_bet","defaultMessage":"A fogadáshoz jelentkezz be","track":"Login to Bet"}}